import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  requestUpdateSingleTemplate,
  setTemplateTitle,
} from "../../../../../redux/actions/single-template";
import { SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const template = useSelector(
    (state) => state.singleTemplate.details && state.singleTemplate.details
  );
  const updateLoading = useSelector(
    (state) => state.singleTemplate.updateTemplate.loading
  );
  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const handleNameChange = (title) => {
    dispatch(setTemplateTitle(title));
  };

  const clickUpdateTemplate = () => {
    if (template.type === "email") {
      dispatch(
        requestUpdateSingleTemplate({
          companyId: companyId,
          templateId: template.id,
          type: "email",
          template: {
            title: template.title,
            html: template.html,
          },
        })
      );
    } else {
      dispatch(
        requestUpdateSingleTemplate({
          companyId: companyId,
          templateId: template.id,
          type: "sms",
          template: {
            title: template.title,
            message: template.message,
          },
        })
      );
    }
  };

  return (
    <div className="single-template-form-container">
      <Row className="single-result-row statistics-row">
        <Col className="result-col text-left">
          <Label version={1} weight="bold">
            Navn på mal
          </Label>
          <Input
            onChange={(e) => handleNameChange(e.target.value)}
            value={template.title}
            type="text"
            placeholder="Min mal"
          />
        </Col>
        <Col className="result-col button text-right">
          <SolidButton
            color="blue"
            title={updateLoading ? "Oppdaterer.." : "Oppdater"}
            icon={
              updateLoading ? (
                <i className="fas fa-circle-notch fa-spin"></i>
              ) : (
                <i className="fas fa-sync"></i>
              )
            }
            onClick={() => clickUpdateTemplate()}
          />
        </Col>
      </Row>
      <hr />
    </div>
  );
};

export default Index;
